
import React from 'react'
import { NextPage } from 'next'
import styles from '../../styles/spinner.module.scss'

interface Props { }

const LoadingSpinner: NextPage<Props> = (props: Props) => {
    return (
        <div className={styles.container}>
            <div className={styles.spinner_container}>
                <div className={styles.loading_spinner}>
                </div>
            </div>
            Loading
        </div>

    );
}

export default LoadingSpinner